(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oneness-live-player"] && !Shopify.designMode) return;
  try {
    (function(){
  const panel=document.getElementById('OnenessLivePlayer');if(!panel)return;
  const key='oneness-live-player-v4';let current=null;let opener=null;
  const video=panel.querySelector('.ol-player-video');const drag=panel.querySelector('.ol-player-drag');const bar=panel.querySelector('.ol-player-bar');
  function save(){try{if(current)sessionStorage.setItem(key,JSON.stringify(current));else sessionStorage.removeItem(key);}catch{}}
  function clamp(value,min,max){return Math.max(min,Math.min(value,max));}
  function setBounds(r){panel.style.left=r.left+'px';panel.style.top=r.top+'px';panel.style.width=r.width+'px';panel.style.height=r.height+'px';panel.style.right='auto';panel.style.bottom='auto';}
  function remember(){if(!current||panel.classList.contains('ol-player-compact'))return;const r=panel.getBoundingClientRect();current.bounds={left:r.left,top:r.top,width:r.width,height:r.height};save();}
  const ratio=16/9;const minWidth=300*ratio;
  function fit(){const compact=innerWidth<minWidth+16||innerHeight<320;panel.classList.toggle('ol-player-compact',compact);if(!compact){const r=panel.getBoundingClientRect();const width=clamp(r.width,minWidth,Math.min(innerWidth,innerHeight*ratio));const height=width/ratio;setBounds({left:clamp(r.left,0,innerWidth-width),top:clamp(r.top,0,innerHeight-height),width,height});}return compact;}
  function changedBounds(r,corner,dx,dy,vw,vh){
    if(!corner)return {...r,left:clamp(r.left+dx,0,vw-r.width),top:clamp(r.top+dy,0,vh-r.height)};
    const west=corner.includes('w'),north=corner.includes('n');
    const anchorX=west?r.left+r.width:r.left,anchorY=north?r.top+r.height:r.top;
    const dw=west?-dx:dx,dh=(north?-dy:dy)*ratio;
    const change=Math.abs(dw)>=Math.abs(dh)?dw:dh;
    const maxWidth=Math.min(west?anchorX:vw-anchorX,(north?anchorY:vh-anchorY)*ratio);
    const width=clamp(r.width+change,Math.min(minWidth,maxWidth),maxWidth),height=width/ratio;
    return {left:west?anchorX-width:anchorX,top:north?anchorY-height:anchorY,width,height};
  }
  function resolveSource(raw){
    if(typeof raw!=='string')return null;raw=raw.trim();
    if(/^[a-zA-Z0-9_]{1,25}$/.test(raw))raw='https://www.twitch.tv/'+raw;
    let url;try{url=new URL(raw);}catch{return null;}
    if(url.protocol!=='https:'||url.username||url.password)return null;
    const host=url.hostname.toLowerCase();const parts=url.pathname.split('/').filter(Boolean);
    const result={source:url.href,external:url.href,embed:null,chat:null,platform:'Stream'};
    if(['twitch.tv','www.twitch.tv','m.twitch.tv'].includes(host)&&parts.length===1&&/^[a-zA-Z0-9_]{1,25}$/.test(parts[0])){
      const channel=parts[0].toLowerCase();const embed=new URL('https://player.twitch.tv/');embed.searchParams.set('channel',channel);embed.searchParams.append('parent',location.hostname);if(window.top!==window.self)embed.searchParams.append('parent','admin.shopify.com');embed.searchParams.set('autoplay','true');embed.searchParams.set('muted','true');
      Object.assign(result,{embed:embed.href,external:'https://www.twitch.tv/'+channel,chat:'https://www.twitch.tv/popout/'+channel+'/chat?popout=',platform:'Twitch'});
    }else if(['kick.com','www.kick.com'].includes(host)&&parts.length===1&&/^[a-zA-Z0-9_-]{1,50}$/.test(parts[0])){
      Object.assign(result,{embed:'https://player.kick.com/'+encodeURIComponent(parts[0])+'?autoplay=true',platform:'Kick'});
    }else if(['youtube.com','www.youtube.com','m.youtube.com','youtu.be','www.youtu.be'].includes(host)){
      let id=host.endsWith('youtu.be')?parts[0]:parts[0]==='watch'?url.searchParams.get('v'):['live','embed','shorts'].includes(parts[0])?parts[1]:null;
      if(id&&/^[a-zA-Z0-9_-]{11}$/.test(id))Object.assign(result,{embed:'https://www.youtube.com/embed/'+id+'?autoplay=1&playsinline=1',external:'https://www.youtube.com/watch?v='+id,platform:'YouTube'});
    }
    return result.embed?result:null;
  }
  function loadPlayer(){video.replaceChildren();const compact=fit();const resolved=resolveSource(current.source);if(!resolved)return;if(compact&&resolved.platform==='Twitch'&&panel.clientWidth<400){const p=document.createElement('p');p.textContent=panel.dataset.mobileNote;video.append(p);return;}const frame=document.createElement('iframe');frame.src=resolved.embed;frame.title=current.name+' — '+resolved.platform;frame.allowFullscreen=true;frame.allow='autoplay; fullscreen; picture-in-picture; encrypted-media';frame.referrerPolicy='strict-origin-when-cross-origin';video.append(frame);}
  function open(source,name,restore=false){const resolved=resolveSource(source);if(!resolved)return;if(current?.source===resolved.source&&!panel.hidden)return;current={source:resolved.source,name:String(name||resolved.platform).slice(0,100),bounds:restore?current?.bounds:{left:Math.max(0,(innerWidth-minWidth)/2),top:Math.max(0,(innerHeight-300)/2),width:minWidth,height:300}};panel.querySelector('[data-ol-player-name]').textContent=current.name;panel.hidden=false;if(current.bounds&&['left','top','width','height'].every(k=>Number.isFinite(current.bounds[k])))setBounds(current.bounds);loadPlayer();remember();save();if(!restore)drag.focus({preventScroll:true});}
  function close(){finish();video.replaceChildren();panel.hidden=true;current=null;save();if(opener?.isConnected)opener.focus();}
  document.addEventListener('click',event=>{const button=event.target.closest('[data-ol-watch]');if(button){const source=button.dataset.source||button.dataset.channel||'';if(!resolveSource(source)){alert(panel.dataset.invalid);return;}opener=button;open(source,button.dataset.creator);}});
  panel.querySelector('[data-ol-close]').addEventListener('click',close);
  panel.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();close();}});
  let gesture=null;
  function finish(){const previous=gesture;gesture=null;panel.classList.remove('ol-player-moving');if(previous?.target.hasPointerCapture(previous.id))previous.target.releasePointerCapture(previous.id);remember();}
  function start(event,corner){if(event.button!==0||panel.classList.contains('ol-player-compact'))return;if(!corner&&event.target.closest('[data-ol-close]'))return;event.preventDefault();const r=panel.getBoundingClientRect();gesture={id:event.pointerId,target:event.currentTarget,x:event.clientX,y:event.clientY,corner,rect:{left:r.left,top:r.top,width:r.width,height:r.height}};panel.classList.add('ol-player-moving');event.currentTarget.setPointerCapture(event.pointerId);}
  bar.addEventListener('pointerdown',event=>start(event,null));
  panel.querySelectorAll('[data-ol-resize]').forEach(handle=>handle.addEventListener('pointerdown',event=>start(event,handle.dataset.olResize)));
  panel.addEventListener('pointermove',event=>{if(!gesture||event.pointerId!==gesture.id)return;setBounds(changedBounds(gesture.rect,gesture.corner,event.clientX-gesture.x,event.clientY-gesture.y,innerWidth,innerHeight));});
  panel.addEventListener('pointerup',finish);panel.addEventListener('pointercancel',finish);panel.addEventListener('lostpointercapture',finish);window.addEventListener('blur',finish);
  function keyboardAdjust(event,corner){if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)||panel.classList.contains('ol-player-compact'))return;event.preventDefault();panel.classList.add('ol-player-moving');const r=panel.getBoundingClientRect();const step=event.shiftKey?1:20;setBounds(changedBounds({left:r.left,top:r.top,width:r.width,height:r.height},corner,event.key==='ArrowRight'?step:event.key==='ArrowLeft'?-step:0,event.key==='ArrowDown'?step:event.key==='ArrowUp'?-step:0,innerWidth,innerHeight));}
  drag.addEventListener('keydown',event=>keyboardAdjust(event,null));
  panel.querySelectorAll('[data-ol-resize]').forEach(handle=>handle.addEventListener('keydown',event=>keyboardAdjust(event,handle.dataset.olResize)));
  panel.addEventListener('keyup',finish);panel.addEventListener('focusout',()=>{if(!gesture)finish();});
  window.addEventListener('resize',()=>{if(panel.hidden)return;finish();const wasCompact=panel.classList.contains('ol-player-compact');const isCompact=fit();if(wasCompact!==isCompact||(isCompact&&current&&resolveSource(current.source)?.platform==='Twitch'))loadPlayer();remember();});
  try{const saved=JSON.parse(sessionStorage.getItem(key));if(saved&&resolveSource(saved.source||saved.channel)){current={source:saved.source||saved.channel,name:saved.name,bounds:saved.bounds};open(saved.source||saved.channel,saved.name,true);}}catch{}
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oneness-talk-terminal"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-oneness-talk]');
  const launcher = document.querySelector('[data-otalk-launcher]');
  if (!root || !launcher || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const key = 'oneness-talk:window:v2';
  const mobile = matchMedia('(max-width:640px)');
  const $ = s => root.querySelector(s);
  let stored = {};
  try { stored = JSON.parse(sessionStorage.getItem(key)) || {}; } catch (_) {}
  let geometry = stored.geometry;
  let expanded = stored.expanded === true;
  let open = false;
  const guestKey = 'oneness-talk:guest:v1';
  let guest = {};
  try { guest = JSON.parse(sessionStorage.getItem(guestKey)) || {}; } catch (_) {}
  if (typeof guest.id !== 'string' || !/^Guest \d{3,6}$/.test(guest.id)) guest.id = `Guest ${Math.floor(Math.random()*900000)+100000}`;
  const nameInput = $('[data-otalk-name]');
  nameInput.value = typeof guest.name === 'string' ? guest.name.slice(0,32) : '';
  nameInput.placeholder = guest.id;
  function isReservedName(value) {
    const normalized = value.normalize('NFKD').toLowerCase()
      .replace(/[0οо]/g,'o').replace(/[еε3]/g,'e').replace(/[ѕ5$]/g,'s')
      .replace(/[\p{M}\p{Cf}]/gu,'').replace(/[^a-z0-9]/g,'');
    return normalized.includes('oneness');
  }
  function saveGuest() {
    const candidate = nameInput.value.trim().slice(0,32);
    const reserved = isReservedName(candidate);
    nameInput.setCustomValidity(reserved ? 'That name is reserved for ONENESS.' : '');
    nameInput.setAttribute('aria-invalid',String(reserved));
    $('[data-otalk-name-error]').hidden = !reserved;
    $('.otalk__transmit').disabled = reserved;
    guest.name = reserved ? '' : candidate;
    try { sessionStorage.setItem(guestKey,JSON.stringify(guest)); } catch (_) {}
    return !reserved;
  }
  nameInput.addEventListener('input',saveGuest);
  saveGuest();
  let opener = launcher;
  let gesture = null;
  const clamp = (n,min,max) => Math.min(Math.max(n,min),Math.max(min,max));
  const validGeometry = g => g && ['x','y','w','h'].every(k => Number.isFinite(g[k]));
  const bounds = () => ({w:window.innerWidth,h:window.innerHeight});
  function fit(g) {
    const v=bounds(), margin=12;
    const w=clamp(g.w,Math.min(420,v.w-24),v.w-24);
    const h=clamp(g.h,Math.min(360,v.h-24),v.h-24);
    return {w,h,x:clamp(g.x,margin,v.w-w-margin),y:clamp(g.y,margin,v.h-h-margin)};
  }
  function initialGeometry() {
    const v=bounds(),w=Math.min(680,v.w-64),h=Math.min(680,v.h-48);
    return fit({x:24,y:v.h-h-24,w,h});
  }
  if (!validGeometry(geometry)) geometry=initialGeometry();
  let sizeUpgrade = stored.sizeVersion !== 3;
  let placementUpgrade = stored.placementVersion !== 1;
  function save() { try { sessionStorage.setItem(key,JSON.stringify({open,expanded,geometry,sizeVersion:sizeUpgrade?stored.sizeVersion:3,placementVersion:placementUpgrade?stored.placementVersion:1})); } catch (_) {} }
  function layout() {
    if (!mobile.matches) {
      if(sizeUpgrade) {
        const h=Math.min(Math.max(geometry.h,680),bounds().h-48);
        geometry={...geometry,h,y:geometry.y+geometry.h-h};
        sizeUpgrade=false;
      }
      if(placementUpgrade) { geometry={...geometry,x:24,y:bounds().h-geometry.h-24};placementUpgrade=false; }
      geometry=fit(geometry);
      const v=bounds();
      const g=expanded?{x:12,y:12,w:v.w-24,h:v.h-24}:geometry;
      for (const [k,n] of Object.entries(g)) root.style.setProperty(`--otalk-${k}`,`${n}px`);
    }
    $('[data-otalk-expand]').textContent=expanded?'RESTORE':'EXPAND';
    $('[data-otalk-expand]').setAttribute('aria-pressed',String(expanded));
    $('[data-otalk-expand]').setAttribute('aria-label',expanded?'Restore terminal size':'Expand terminal');
  }
  function formatEasternTime(date) {
    return date.toLocaleTimeString('en-US',{timeZone:'America/New_York',hour:'numeric',minute:'2-digit',hour12:true}) + ' ET';
  }
  function show(focus=true) {
    open=true; root.hidden=false; launcher.hidden=true; launcher.setAttribute('aria-expanded','true'); layout();save();
    if(focus) $('[data-otalk-close]').focus({preventScroll:true});
  }
  function hide() {
    open=false; root.hidden=true; launcher.hidden=false;launcher.setAttribute('aria-expanded','false');save();
    (opener?.isConnected?opener:launcher).focus({preventScroll:true});
  }
  launcher.hidden=false;
  document.addEventListener('click',e=>{
    const trigger=e.target.closest('[data-otalk-launcher],[data-otalk-open]');
    if(trigger) { opener=trigger;show(); }
  });
  root.querySelectorAll('[data-otalk-close]').forEach(b=>b.addEventListener('click',hide));
  $('[data-otalk-service]').addEventListener('click',e=>{ if(!e.ctrlKey&&!e.metaKey&&!e.shiftKey&&!e.altKey)hide(); });
  $('[data-otalk-expand]').addEventListener('click',()=>{ expanded=!expanded;layout();save(); });
  function start(e,type) {
    if(mobile.matches || expanded || e.button!==0)return;
    if(type==='move' && e.target.closest('button,a,input'))return;
    gesture={type,x:e.clientX,y:e.clientY,start:{...geometry},target:e.currentTarget,id:e.pointerId};
    e.currentTarget.setPointerCapture(e.pointerId);root.classList.add('is-manipulating');root.classList.toggle('is-dragging',type==='move');e.preventDefault();
  }
  function move(e) {
    if(!gesture || e.pointerId!==gesture.id)return;
    const g=gesture.start,dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
    geometry=fit(gesture.type==='move'?{...g,x:g.x+dx,y:g.y+dy}:{...g,w:Math.min(g.w+dx,innerWidth-g.x-12),h:Math.min(g.h+dy,innerHeight-g.y-12)});layout();
  }
  function stop() { if(!gesture)return;gesture=null;root.classList.remove('is-manipulating','is-dragging');save(); }
  for(const [selector,type] of [['[data-otalk-drag]','move'],['[data-otalk-resize]','resize']]) {
    const control=$(selector);control.addEventListener('pointerdown',e=>start(e,type));control.addEventListener('pointermove',move);control.addEventListener('pointerup',stop);control.addEventListener('pointercancel',stop);control.addEventListener('lostpointercapture',stop);
  }
  for(const [selector,type] of [['[data-otalk-drag]','move'],['[data-otalk-resize]','resize']]) {
    $(selector).addEventListener('keydown',e=>{
      if(e.target!==e.currentTarget)return;
      if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key)||mobile.matches||expanded)return;
      e.preventDefault();const step=e.shiftKey?40:10;
      const horizontal=e.key==='ArrowLeft'||e.key==='ArrowRight';const prop=type==='move'?(horizontal?'x':'y'):(horizontal?'w':'h');
      geometry[prop]+=step*(e.key==='ArrowLeft'||e.key==='ArrowUp'?-1:1);geometry=fit(geometry);layout();save();
    });
  }
  root.addEventListener('keydown',e=>{
    if(e.key==='Escape') {
      hide();
      e.stopPropagation();
    }
  });
  window.addEventListener('resize',()=>{layout();save();});
  window.addEventListener('pagehide',save);
  if(stored.open===true || (!('open' in stored)&&document.querySelector('.otalk-entry')))show(false);
})();
  } catch(e) { console.error(e); }
})();

})();
